import React, { useEffect } from 'react'
import { Outlet, Navigate, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { cardDetailsAction } from '../features/user/userSlice'
import { ROUTES } from '../routes'

const NocardGuard = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const usersData = useSelector((state) => state?.users)
  const cardList = usersData?.cardList

  useEffect(() => {
    if (cardList === null) {
      dispatch(cardDetailsAction())
    }
  }, [cardList, dispatch])

  if (cardList === null) {
    return null
  }

  const cards = Array.isArray(cardList) ? cardList.filter(card => card.status !== 'canceled') : []
  const hasNoCards = cards.length === 0
  const isStblMoneyRoute = location.pathname.startsWith(ROUTES.STBL_MONEY)


  if (isStblMoneyRoute && hasNoCards) {
    return <Navigate to={ROUTES.APPLY_CARD} replace />
  }

  return (
    <>
      <Outlet />
    </>
  )
}

export default NocardGuard